<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="fas fa-pound-sign mr-4"></i>Pending Purchase Orders</span>
        </h1>
        <main class="overflow-hidden flex-1 place-content-center">
            <div v-if="package" class="flex flex-col text-gray-500 cursor-pointer" @click="go">
                <div class="w-full text-center text-5xl hover:text-brand" v-if="parseInt(package.accounts.pending_po_count)" v-text="parseInt(package.accounts.pending_po_count)"></div>
                <div class="place-content-center w-full" v-else>
                    <div class="flex flex-col text-gray-500">
                        <div class="w-full text-center font-bold text-md"><span><i
                            class="text-lg text-green-600 far fa-check mr-4"></i></span>No pending POs
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            package: null,
        }
    },
    computed: {},
    methods: {
        go(){
            window.document.location = this.package._links.frontend.purchase_orders
        }
    },
    mounted() {
        this.package = this.dashboardProps.legacyPackage
    }
}

</script>